import { getUserData } from '@/auth/utils'
import jwtPythonApi from './jwtPythonApi'

class JwtServiceMore {
  constructor() {
    Object.assign(JwtServiceMore.prototype, jwtPythonApi)
  }

  getCalendarTemplate(...args) {
    return this.axiosIns.get(`${this.jwtConfig.calendarEventTemplateEndpoint}`, ...args)
  }

  storeCalendarTemplate(...args) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventTemplateEndpoint}`, ...args)
  }

  showCalendarTemplate(id, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.calendarEventTemplateEndpoint}/${id}`, ...args)
  }

  updateCalendarTemplate(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.calendarEventTemplateEndpoint}/${id}`, ...args)
  }

  deleteCalendarTemplate(id) {
    return this.axiosIns.delete(`${this.jwtConfig.calendarEventTemplateEndpoint}/${id}`)
  }

  applyCalendarTemplate(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventTemplateEndpoint}/${id}/apply`, ...args)
  }

  cloneCalendarTemplate(id) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventTemplateEndpoint}/${id}/clone`)
  }

  toggleCalendarTemplateVisibility(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.calendarEventTemplateEndpoint}/${id}/visibility`, ...args)
  }

  //   Verify Workzone
  verfiyWorkzoneLogin() {
    return this.axiosIns.get(`${this.jwtConfig.verfiyWorkzoneLogin}`)
  }

  getGameReport(id, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.gameEndPoint}/get-game-report/${id}`, ...args)
  }

  getEbookByVersions(lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonPagesEndpoint}/${lessonId}/get-ebook`, ...args)
  }

  getStudentRoleStat({ userId, classId }) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${userId}/scoreboards/${classId}`)
  }

  getStudentNoteStat({ userId, classId }) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${userId}/notes/${classId}`)
  }

  getGroupNoteReport(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/notes-report`)
  }

  getGroupChatReport(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/chat-report`)
  }

  getScheduleReport(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/schedule`)
  }

  getRoleReport(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/role-report`)
  }

  getStudentPaired(...args) {
    return this.axiosIns.get(`${this.jwtConfig.paringEndpoint}/get-all-students`, ...args)
  }

  getProblemScore(testId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/get-problem-score/${testId}`)
  }

  updateProblemScore(testId, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.apiEndPoint}/update-problem-score/${testId}`, ...args)
  }

  getSpeechAccuracyByTestStat(testId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/get-speech-accuracy/${testId}`, ...args)
  }

  updateOpenAiScore(testId, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.apiEndPoint}/update-open-ai-score/${testId}`, ...args)
  }

  getScormPlayer(uuid) {
    return this.axiosIns.get(`${this.jwtConfig.scormEndPoint}/play/${uuid}`)
  }

  getScormList() {
    return this.axiosIns.get(`${this.jwtConfig.scormEndPoint}`)
  }

  getScormReport(scosUiId) {
    return this.axiosIns.get(`${this.jwtConfig.scormEndPoint}/track/${scosUiId}/get-report`)
  }

  getGecScromList() {
    return this.axiosIns.get(`${this.jwtConfig.scormEndPoint}/lists`)
  }

  deleteScorm(id) {
    return this.axiosIns.delete(`${this.jwtConfig.scormEndPoint}/${id}`)
  }

  showLibrary(id, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.libraryEndPoint}/${id}`, ...args)
  }

  translateLibrary(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}/translate/${id}`, ...args)
  }

  updateBlockedUserCourses(...args) {
    return this.axiosIns.post(`${this.jwtConfig.libraryEndPoint}/update-blocked-course`, ...args)
  }

  getBlockedUserCourses(userId) {
    return this.axiosIns.get(`${this.jwtConfig.libraryEndPoint}/blocked-course/${userId}`)
  }

  storeSchoolLibrary(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.libraryEndPoint}/${id}/update-school`, ...args)
  }

  storeLibrary(...args) {
    return this.axiosIns.post(`${this.jwtConfig.libraryEndPoint}`, ...args)
  }

  updateLibrary(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.libraryEndPoint}/${id}`, ...args)
  }

  getLibrary(...args) {
    return this.axiosIns.get(`${this.jwtConfig.libraryEndPoint}`, ...args)
  }

  requestLibrary(...args) {
    return this.axiosIns.post(`${this.jwtConfig.libraryEndPoint}/request`, ...args)
  }

  toggleStatementFeedBackAnimationTemplate(templateId, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.animationTemplateEndPoint}/statement-feedback-toggle/${templateId}`, ...args)
  }

  // animation template
  saveAnimationTemplate(...args) {
    return this.axiosIns.post(`${this.jwtConfig.animationTemplateEndPoint}`, ...args)
  }

  // animation-template/bulk-update/{lesson}
  bulkUpdateAnimatedTemplate(lesson, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.animationTemplateEndPoint}/bulk-update/${lesson}`, ...args)
  }

  toggleAnimationTemplate(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.animationTemplateEndPoint}/toggle/${id}`, ...args)
  }

  createAnimationTemplate(...args) {
    return this.axiosIns.post(`${this.jwtConfig.animationTemplateEndPoint}`, ...args)
  }

  saveAnimationTemplateCopy(id, args) {
    return this.axiosIns.post(`${this.jwtConfig.animationTemplateEndPoint}/save-from/${id}`, args)
  }

  getSavedAnimationTemplateCopy() {
    return this.axiosIns.get(`${this.jwtConfig.animationTemplateEndPoint}/get-saved-template`)
  }

  updateAnimationTemplate(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.animationTemplateEndPoint}/${id}`, ...args)
  }

  destroyAnimationTemplate(id) {
    return this.axiosIns.delete(`${this.jwtConfig.animationTemplateEndPoint}/${id}`)
  }

  getAnimationTemplate(id) {
    return this.axiosIns.get(`${this.jwtConfig.animationTemplateEndPoint}/${id}`)
  }

  toggleAllVisibility(action, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.problemVisibilityEndpoint}/${action}`, ...args)
  }

  getStudentProblemSets(...args) {
    return this.axiosIns.get(`${this.jwtConfig.problemSetsEndPoint}/student-sets`, ...args)
  }

  updateStudentProblemSets(...args) {
    return this.axiosIns.post(`${this.jwtConfig.problemSetsEndPoint}/update-sets`, ...args)
  }

  // for builder
  getProblemSetWrapperLists(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.problemSetsEndPoint}/get-problem-set/${lessonId}`)
  }

  createProblemSetWrapper(lessonId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.problemSetsEndPoint}/create-set/${lessonId}`, ...args)
  }

  deleteProblemSetWrapper(setId) {
    return this.axiosIns.delete(`${this.jwtConfig.problemSetsEndPoint}/delete-set/${setId}`)
  }

  checkAndGetClassTests(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/check-and-get-class-tests`)
  }

  // reservations
  getReservations(...args) {
    return this.axiosIns.get(this.jwtConfig.reservationEndPoint, ...args)
  }

  storeReservations(form) {
    return this.axiosIns.post(this.jwtConfig.reservationEndPoint, form)
  }

  showReservations(id) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/${id}`)
  }

  updateReservations(id, form) {
    return this.axiosIns.put(`${this.jwtConfig.reservationEndPoint}/${id}`, form)
  }

  deleteReservations(id) {
    return this.axiosIns.delete(`${this.jwtConfig.reservationEndPoint}/${id}`)
  }

  getShopifyProducts(collection) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/get-shopify-product/${collection}`)
  }

  updateShopifyProductsForReservation(reservationId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/update-shopify-product/${reservationId}`, ...args)
  }

  getAvailableReservation(...args) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/get-reservations`, ...args)
  }

  storePublicReservation(form) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/public/store`, form)
  }

  getPublicReservation(...args) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/public/list`, ...args)
  }

  destroyPublicReservation(id) {
    return this.axiosIns.delete(`${this.jwtConfig.reservationEndPoint}/public/delete/${id}`)
  }

  getDefaultClassroom(...args) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/get-default-classroom`, ...args)
  }

  reservationToClassRoom(form) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/reservation-to-class`, form)
  }

  getReservationPublicClassRoom(id) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/${id}/get-reservation-public-class`)
  }

  getPublicSchools() {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/public/schools`)
  }

  getSchoolReservation(schoolId) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}?schoolId=${schoolId}`)
  }

  onConfirmTeacherReservation(form) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/reserve-schedule`, form)
  }

  getPageFromProblem(problemId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/get-page-from-problem/${problemId}`)
  }

  getMismatchedCbProblems(...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/check-cb-lesson-problem`, ...args)
  }

  //   Market Places

  getMarketPlaces(...args) {
    return this.axiosIns.get(this.jwtConfig.marketPlaceEndPoint, ...args)
  }

  getSchoolMarketPlaces(id, form) {
    return this.axiosIns.get(`${this.jwtConfig.marketPlaceEndPoint}/school-marketplaces/${id}`, form)
  }

  storeMarketPlaces(form) {
    return this.axiosIns.post(this.jwtConfig.marketPlaceEndPoint, form)
  }

  showMarketPlace(id) {
    return this.axiosIns.get(`${this.jwtConfig.marketPlaceEndPoint}/${id}`)
  }

  updateMarketPlaces(id, form) {
    return this.axiosIns.put(`${this.jwtConfig.marketPlaceEndPoint}/${id}`, form)
  }

  changeMarketPlacesStatus(id, form) {
    return this.axiosIns.post(`${this.jwtConfig.marketPlaceEndPoint}/change-status/${id}`, form)
  }

  deleteMarketPlaces(id) {
    return this.axiosIns.delete(`${this.jwtConfig.marketPlaceEndPoint}/${id}`)
  }

  getSignalClassroomOverallReport(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/overall-report`)
  }

  getOverallClassroomReport(...args) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/overall-classroom-report`, ...args)
  }

  //   Animated Items

  getAnimatedItems(...args) {
    return this.axiosIns.get(`${this.jwtConfig.animatedItemsEndpoint}`, ...args)
  }

  getAnimatedMarketplace() {
    return this.axiosIns.get(`${this.jwtConfig.animatedItemsEndpoint}-marketplace`)
  }

  storeAnimatedItems(form) {
    return this.axiosIns.post(`${this.jwtConfig.animatedItemsEndpoint}`, form)
  }

  updateAnimatedItems(id, form) {
    return this.axiosIns.put(`${this.jwtConfig.animatedItemsEndpoint}/${id}`, form)
  }

  deleteAnimatedItems(id) {
    return this.axiosIns.delete(`${this.jwtConfig.animatedItemsEndpoint}/${id}`)
  }

  buyAnimatedItems(id) {
    return this.axiosIns.get(`${this.jwtConfig.animatedItemsEndpoint}/buy/${id}`)
  }

  myAnimatedItems(character = 'all') {
    return this.axiosIns.get(`${this.jwtConfig.animatedItemsEndpoint}/user/my-items/${character}`)
  }

  getSelectedOutfits() {
    return this.axiosIns.get(`${this.jwtConfig.animatedItemsEndpoint}/user/selected-outfits`)
  }

  updateSelectedOutfits(form) {
    return this.axiosIns.post(`${this.jwtConfig.animatedItemsEndpoint}/user/selected-outfit/update`, form)
  }

  //   Trading of Animated Items
  getTradedItems() {
    return this.axiosIns.get(`${this.jwtConfig.animatedItemsTradingEndpoint}`)
  }

  sellAnimatedItems(form) {
    return this.axiosIns.post(`${this.jwtConfig.animatedItemsTradingEndpoint}/sell`, form)
  }

  buyTradingAnimatedItems(id, form) {
    return this.axiosIns.post(`${this.jwtConfig.animatedItemsTradingEndpoint}/buy/${id}`, form)
  }

  removeStatementFeedBackTemplate(templateId) {
    return this.axiosIns.delete(`${this.jwtConfig.problemTemplatesEndpoint}/${templateId}`)
  }

  getLanguageLevelByCourse(...args) {
    return this.axiosIns.get(`${this.jwtConfig.globalSettingEndpoint}/get-lang-level`, ...args)
  }

  getLanguageLevelIndicatorBySchool(schoolId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.globalSettingEndpoint}/lang-level-indicator/${schoolId}`, ...args)
  }

  getHigherLevelReport(...args) {
    return this.axiosIns.get(`${this.jwtConfig.higherLevelReportingEndPoint}`, ...args)
  }

  // AI analysis of one higher level report row (numbers only)
  getHigherLevelReportInsight(payload, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.higherLevelReportInsightEndPoint}`, payload, ...args)
  }

  getAIUsageReport(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.aiUsageReportEndPoint}`, { params })
  }

  getAIModelRates() {
    return this.axiosIns.get(`${this.jwtConfig.aiModelRatesEndPoint}`)
  }

  updateAIModelRates(payload) {
    return this.axiosIns.put(`${this.jwtConfig.aiModelRatesEndPoint}`, payload)
  }

  getAcademicVideoJobsReport(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.academicVideoJobsReportEndPoint}`, { params })
  }

  restoreUser(id, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.userEndpoint}/restore/${id}`, ...args)
  }

  updateClassroomScript(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.classEndpoint}/${id}/scripts`, ...args)
  }

  getClassroomScript(id) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${id}/scripts`)
  }

  // report
  getCalibratedClassCourseReport(classId, courseId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.calibratedReportEndPoint}/${classId}/course/${courseId}`, ...args)
  }

  getCalibratedClassLessonReport(classId, lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.calibratedReportEndPoint}/${classId}/lesson/${lessonId}`, ...args)
  }

  getCalibratedCourseUserReport(classId, courseId, userId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.calibratedReportEndPoint}/${classId}/course/${courseId}/user/${userId}`, ...args)
  }

  getCourseListForReport(roomId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/reports/classroom/${roomId}/courses`)
  }

  getClassroomPublicScript() {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/classroom-script/public-script`)
  }

  applyClassroomPublicScript(id, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.classEndpoint}/${id}/apply-public-script`, ...args)
  }

  getIndividualUserReport(userId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/user-all-report/${userId}`, ...args)
  }

  getIndividualUserStudyTimeReport({ userId, classId }, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/get-user-study-time/${classId}/${userId}`, ...args)
  }

  getIndividualUserCourseGraphReport(userId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/user-all-report/lesson-group-graph/${userId}`, ...args)
  }

  // roles
  storeRoles(...args) {
    return this.axiosIns.post(`${this.jwtConfig.rolesEndpoint}/store`, ...args)
  }

  updateRoles(role, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.rolesEndpoint}/update/${role}`, ...args)
  }

  deleteRoles(role, ...args) {
    return this.axiosIns.delete(`${this.jwtConfig.rolesEndpoint}/delete/${role}`, ...args)
  }

  getRoles(...args) {
    return this.axiosIns.get(`${this.jwtConfig.rolesEndpoint}/index`, ...args)
  }

  getModuleRoles(...args) {
    return this.axiosIns.get(`${this.jwtConfig.rolesEndpoint}/module-role`, ...args)
  }

  searchPermission(...args) {
    return this.axiosIns.get(`${this.jwtConfig.permissionsEndpoint}/permission-search`, ...args)
  }

  // student calibration
  saveStudentCalibration(...args) {
    return this.axiosIns.post(`${this.jwtConfig.calibratedReportEndPoint}/save-student-calibration`, ...args)
  }

  // student calibration
  getStudentCalibration(classId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.calibratedReportEndPoint}/${classId}/get-student-calibration`, ...args)
  }

  // student calibration cefr
  getStudentCalibrationCefr(classId, lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/cefr/classroom/${classId}/lesson/${lessonId}`, ...args)
  }

  // image library api
  getImageLibrary(...args) {
    return this.axiosIns.get(`${this.jwtConfig.imageLibraryEndpoint}`, ...args)
  }

  storeImageLibrary(...args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}`, ...args)
  }

  updateImageLibrary(imageId, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.imageLibraryEndpoint}/${imageId}`, ...args)
  }

  updateImageLibraryWithGenerateImage(...args) {
    return this.axiosIns.put(`${this.jwtConfig.imageLibraryEndpoint}/update/generated-img`, ...args)
  }

  deleteImageLibrary(imageId) {
    return this.axiosIns.delete(`${this.jwtConfig.imageLibraryEndpoint}/${imageId}`)
  }

  getImageLibraryById(imageId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.imageLibraryEndpoint}/${imageId}`, ...args)
  }

  saveImageLibraryWord(...args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}/regenerate`, ...args)
  }

  regenerateImgLibrary(args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}/sync-imgs`, args)
  }

  saveImageLibraryWordForGeneratedWord(id, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.wordsForParagraphEndPoint}/${id}/generate-from-lib`, ...args)
  }

  getOnProgressFailedImages() {
    return this.axiosIns.get(`${this.jwtConfig.failedOnprogressImageLibrary}`)
  }

  getWordSelectionByLesson(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.wordsForParagraphEndPoint}/${lessonId}/words`)
  }

  imageLibraryBulkUpload(...args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryBulkUploadEndpoint}`, ...args)
  }

  updateStudentLessonCalibration(lessonId) {
    return this.axiosIns.post(`${this.jwtConfig.calibratedReportEndPoint}/update-student-calibration/${lessonId}`)
  }

  getEssayCounts(classId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/essay/count`)
  }

  getCefrStatusOfLesson(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.calibratedReportEndPoint}/${lessonId}/status`)
  }

  updateCefrStatusOfLesson(lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/cefr/classroom/${lessonId}/sync`, ...args)
  }

  //   Get classroom for user
  getClassRoomOfUser(user) {
    return this.axiosIns.get(`${this.jwtConfig.classRoomEndpoint}/${user}`)
  }

  getClassRoomSettings(id) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${id}/settings`)
  }

  getVrLessons(...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/vr-lessons`, ...args)
  }

  getSchoolSettings() {
    if (!getUserData()) {
      return new Promise(resolve => {
        resolve({})
      })
    }
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/get-school-enhancement/setting`)
  }

  updateSchoolSettings(type, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.classEndpoint}/update-school-enhancement/${type}`, ...args)
  }

  updateClassroomSelfStudy(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.classEndpoint}/${id}/selfStudyClassroom`, ...args)
  }

  updateClassroomSetting(id, setting, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.classEndpoint}/${id}/setting/${setting}`, ...args)
  }

  getClassroomSetting(id, setting) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${id}/setting/${setting}`)
  }

  verifyShopifyReservation(...args) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/shopify/verify`, ...args)
  }

  updateUserPermission(...args) {
    return this.axiosIns.post(`${this.jwtConfig.userPermissionEndpoint}`, ...args)
  }

  storeProblemWithVideo(problemId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.questionEndpoint}/clone-with/${problemId}`, ...args)
  }

  storeMultipleProblemWithVideo(...args) {
    return this.axiosIns.post(`${this.jwtConfig.questionEndpoint}/bulk/clone-with`, ...args)
  }

  getWriteShiftApiResponse(args) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/call-write-shift-api`, args)
  }

  //   Lesson Planner
  getLessonPlanner(...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonPlannerEndpoint}`, ...args)
  }

  createLessonPlanner(...args) {
    return this.axiosIns.post(`${this.jwtConfig.lessonPlannerEndpoint}`, ...args)
  }

  updateLessonPlanner(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.lessonPlannerEndpoint}/${id}`, ...args)
  }

  fetchCurrentLessonPlanner(id, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonPlannerEndpoint}/${id}/edit`, ...args)
  }

  removeLessonPlanner(id, all = 0) {
    return this.axiosIns.delete(`${this.jwtConfig.lessonPlannerEndpoint}/${id}?${all ? `all=${all}` : ''}`)
  }

  getLessonWords(...args) {
    return this.axiosIns.get(this.jwtConfig.lessonWordEndPoint, ...args)
  }

  // ai-ide
  showAiIdePage(...args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/get-page`, ...args)
  }

  destroyAiIdePage(id) {
    return this.axiosIns.delete(`${this.jwtConfig.aiIdeEndPoint}/ide-pages/${id}`)
  }

  storeAiIdePage(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/ide-pages`, ...args)
  }

  createAiIdeProcess(pageId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/create-process/${pageId}`, ...args)
  }

  createAiIdeTask(pageId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/create-task/${pageId}`, ...args)
  }

  destroyAiIdeTask(id) {
    return this.axiosIns.delete(`${this.jwtConfig.aiIdeEndPoint}/delete-task/${id}`)
  }

  updateAiIdeProcess(id, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.aiIdeEndPoint}/update-process/${id}`, ...args)
  }

  enableDisableIdeProcess(id, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.aiIdeEndPoint}/enable-process/${id}`, ...args)
  }

  deleteAiIdeProcess(id) {
    return this.axiosIns.delete(`${this.jwtConfig.aiIdeEndPoint}/delete-process/${id}`)
  }

  getStudentBotChatHistory(args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/get-student-chat-history`, args)
  }

  getReaLabChatHistory(...args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/get-rea-chat-history`, ...args)
  }

  getEbookPrompt(pageId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/ebook-prompt/${pageId}`, ...args)
  }

  getPromptForTheLabView(args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/get-prompt-for-lesson`, args)
  }

  saveStudentBotChatHistory(args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/save-student-chat-history`, args)
  }

  getAiConversation(id, args) {
    return this.axiosIns.get(`${this.jwtConfig.aiConversationEndPoint}/${id}`, args)
  }

  saveAiConversationStat(id, args) {
    return this.axiosIns.post(`${this.jwtConfig.aiConversationEndPoint}/${id}/stat`, args)
  }

  completeAiConversation(id, args) {
    return this.axiosIns.post(`${this.jwtConfig.aiConversationEndPoint}/${id}/complete`, args)
  }

  saveStudentBotEssayHistory(args) {
    return this.axiosIns.post(`${this.jwtConfig.reaEndPoint}/context/save-essay`, args)
  }

  getReaContextEvaluation(...args) {
    return this.axiosIns.get(`${this.jwtConfig.reaEndPoint}/context/get-evaluations`, ...args)
  }

  getAiIdeProcessDetail(id) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/process/show/${id}`)
  }

  getBotResponse(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/get-bot-response`, ...args)
  }

  // lesson links
  getLessonLinks(...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonLinkEndpoints}`, ...args)
  }

  getUrlFromLessonLink(id) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/get-lesson-link/${id}`)
  }

  saveLessonLinks(...args) {
    return this.axiosIns.post(`${this.jwtConfig.lessonLinkEndpoints}`, ...args)
  }

  editLessonLinks(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.lessonLinkEndpoints}/${id}`, ...args)
  }

  deleteLessonLinks(id) {
    return this.axiosIns.delete(`${this.jwtConfig.lessonLinkEndpoints}/${id}`)
  }

  changeGlobalCEFR(...args) {
    return this.axiosIns.post(`${this.jwtConfig.cefrScopeEndpoint}`, ...args)
  }

  translateCurriculumLesson(cbPage, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.curriculumPagesEndpoint}/${cbPage}/translate`, ...args)
  }

  getCoursesLessonWithLibrary() {
    return this.axiosIns.get(`${this.jwtConfig.libraryEndPoint}/courses/lessons`)
  }

  getSsoLink(provider) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/sso/login/${provider}`)
  }

  loginWithSSoProvider(...args) {
    return this.axiosIns.post(`${this.jwtConfig.loginEndpoint}/with-provider`, ...args)
  }

  loginWithSSoSmal(...args) {
    return this.axiosIns.post(`${this.jwtConfig.samlEndPoint}/acs/login`, ...args)
  }

  getDefaultChatOfUser(...args) {
    return this.axiosIns.get('/api/v1/default-chat', ...args)
  }

  getReservationSchedules(classId) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/get-class-schedule/${classId}`)
  }

  updateReservationSchedules(classId, scheduleId) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/select-class-schedule/${classId}/${scheduleId}`)
  }

  showScheduleDetail(scheduleId) {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/get-schedule-detail/${scheduleId}`)
  }

  startScheduleClass(scheduleId) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/start-class/${scheduleId}`)
  }

  getStudentScheduleGroup() {
    return this.axiosIns.get(`${this.jwtConfig.reservationEndPoint}/get-student-schedules`)
  }

  getOpenAIScoreForDemo(...args) {
    return this.axiosIns.post(`${this.jwtConfig.getDemoEndpoint}/ai-score`, ...args)
  }

  getBotResponseForDemo(...args) {
    return this.axiosIns.post(`${this.jwtConfig.getDemoEndpoint}/get-ai-bot-score`, ...args)
  }

  convertTextToBase64(...args) {
    return this.axiosIns.post('/api/tts-polly', ...args)
  }

  convertTextToBase64VersionTwo(...args) {
    return this.axiosIns.post('/api/tts-ai-version', ...args)
  }

  /**
   * OpenAI TTS (tts-1, same API key as Whisper STT) as JSON base64.
   * Used when Kokoro fails / is rate-limited in counseling voice replies.
   * POST avoids URL length limits on long assistant replies.
   */
  convertTextToOpenAiBase64(text) {
    return this.axiosIns.post('/api/tts-ai-version', {
      text,
      format: 'base64',
    })
  }

  // payment trail
  verifyReservationPayment(args) {
    return this.axiosIns.post(`${this.jwtConfig.paymentApiEndPoint}/verify-reservation`, args)
  }

  reservationPaymentSuccess(...args) {
    return this.axiosIns.get(`${this.jwtConfig.paymentApiEndPoint}/reservation/payment_success`, ...args)
  }

  reservationSchedulePaymentSuccess(...args) {
    return this.axiosIns.post(`${this.jwtConfig.paymentApiEndPoint}/reservation/select-class-schedule/payment_success`, ...args)
  }

  reservationCreateAndReserveSchedule(reservationId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/${reservationId}/create-custom-schedule`, ...args)
  }

  reserveSelfStudyClassRoom(reservationId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.reservationEndPoint}/${reservationId}/reserve-self-study`, ...args)
  }

  getUserPayments(...args) {
    return this.axiosIns.get(`${this.jwtConfig.paymentApiEndPoint}/user-payments`, ...args)
  }

  reservationPaidUpgrade(reservation, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.paymentApiEndPoint}/reservation/${reservation}/update-to-paid`, ...args)
  }

  reservationUpdateToPaid(...args) {
    return this.axiosIns.post(`${this.jwtConfig.paymentApiEndPoint}/reservation/update-to-paid/payment_success`, ...args)
  }

  getClassRoomLesson(classId, courseId, lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.classEndpoint}/${classId}/get-classroom-lesson?courseId=${courseId}&lessonId=${lessonId}`)
  }

  // Assets Management
  getAssets(...args) {
    return this.axiosIns.get(`${this.jwtConfig.assetsEndpoint}`, ...args)
  }

  storeAssets(...args) {
    return this.axiosIns.post(`${this.jwtConfig.assetsEndpoint}`, ...args)
  }

  updateAssets(assetId, ...args) {
    return this.axiosIns.patch(`${this.jwtConfig.assetsEndpoint}/${assetId}`, ...args)
  }

  deleteAsset(assetId) {
    return this.axiosIns.delete(`${this.jwtConfig.assetsEndpoint}/${assetId}`)
  }

  getLessonInfoForVisualization(...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/lesson-info`, ...args)
  }

  updateLessonPlayTime(loaderId) {
    return this.axiosIns.put(`${this.jwtConfig.apiEndPoint}/update-lesson-time/${loaderId}`)
  }

  getProblemConversionSetting(...args) {
    return this.axiosIns.get(`${this.jwtConfig.schoolSettingsEndpoint}/problem-conversion-setting`, ...args)
  }

  requestPracticeLessonsForClass(...args) {
    return this.axiosIns.post(`${this.jwtConfig.classEndpoint}/request-practice`, ...args)
  }

  getUsersCount(...args) {
    return this.axiosIns.get(`${this.jwtConfig.usersEndpoint}/child/count`, ...args)
  }

  getStudentCountByDateRange(...args) {
    return this.axiosIns.get(`${this.jwtConfig.usersEndpoint}/child/student-count-by-date`, ...args)
  }

  getUsersActivities(page, params = {}, config = {}) {
    return this.axiosIns.get(`${this.jwtConfig.usersEndpoint}/activities`, {
      ...config,
      params: {
        page,
        ...params,
        ...(config.params || {}),
      },
    })
  }

  addUsersToCalibration(...args) {
    return this.axiosIns.post(`${this.jwtConfig.usersEndpoint}/update-calibration`, ...args)
  }

  getUsersCanViewCalibration() {
    return this.axiosIns.get(`${this.jwtConfig.usersEndpoint}/can-view-calibration`)
  }

  // note templates
  getNoteTemplates(...args) {
    return this.axiosIns.get(`${this.jwtConfig.noteTemplateEndPoint}`, ...args)
  }

  storeNoteTemplate(data) {
    return this.axiosIns.post(`${this.jwtConfig.noteTemplateEndPoint}`, data)
  }

  updateNoteTemplate(id, data) {
    return this.axiosIns.put(`${this.jwtConfig.noteTemplateEndPoint}/${id}`, data)
  }

  deleteNoteTemplate(id) {
    return this.axiosIns.delete(`${this.jwtConfig.noteTemplateEndPoint}/${id}`)
  }

  getTeacherNoteWithTemplate() {
    return this.axiosIns.get(`${this.jwtConfig.noteTemplateEndPoint}/teacher/note`)
  }

  speechToTextConversion(args) {
    return this.axiosIns.post('/api/speech-to-text', args, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  bulkCalendarEventUpdate(...args) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventEndpoint}/bulk-update`, ...args)
  }

  bulkCalendarEventDelete(...args) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventEndpoint}/bulk-delete`, ...args)
  }

  updateEventTemplate(eventId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventEndpoint}/${eventId}/update-template`, ...args)
  }

  getEventTemplate(eventId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.calendarEventEndpoint}/${eventId}/assignment-template`, ...args)
  }

  // stable diffusion
  setupImageGeneration(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/setup-image-generation`, ...args)
  }

  saveImageGenerated(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/save-image-generated`, ...args)
  }

  // dall-e-3
  setupImageByDalle(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/setup-image-dalle`, ...args)
  }

  // grok
  setupImageByGrok(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/setup-image-grok`, ...args)
  }

  // ai image edit
  aiEditImage(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/ai-edit-image`, ...args)
  }

  // queue a batch of ai image annotations (progress via getQueueProgress('pdf-image-annotate'))
  bulkAnnotateImages(...args) {
    return this.axiosIns.post(`${this.jwtConfig.aiIdeEndPoint}/bulk-annotate-images`, ...args)
  }

  // replace existing stored image in-place and return cache-busted URL
  replaceImage(...args) {
    return this.axiosIns.post(`${this.jwtConfig.commonEndpoint}/replace-image`, ...args)
  }

  getDiffusionImageStatus(uuid, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/get-image-status/${uuid}`, ...args)
  }

  synchImgLibrary() {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}-sync/sync-img-library`)
  }

  synchImgLibraryOtherVersion(...args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}-sync/sync-other-version`, ...args)
  }

  regenerateImageLibraryAssets(id) {
    return this.axiosIns.put(`${this.jwtConfig.imageLibraryEndpoint}/regenerate/${id}`)
  }

  getQueueProgress(name, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.commonEndpoint}/queue-info/${name}`, ...args)
  }

  getCommandProcess(...args) {
    return this.axiosIns.get(`${this.jwtConfig.commonEndpoint}/command-progress`, ...args)
  }

  deleteCommandProcess(id) {
    return this.axiosIns.delete(`${this.jwtConfig.commonEndpoint}/command-progress/${id}`)
  }

  getProblemDataFromLogs(logId) {
    return this.axiosIns.get(`${this.jwtConfig.gecPartnerEndPoint}/get-problem-data/${logId}`)
  }

  saveOcrProblems(...args) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/ocr-problems`, ...args)
  }

  uploadLaExcelFileUser(args) {
    return this.axiosIns.post(`${this.jwtConfig.gecPartnerEndPoint}/la/excel`, args, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  uploadLaScheduleExcelFileUser(args) {
    return this.axiosIns.post(`${this.jwtConfig.gecPartnerEndPoint}/la/excel-schedule`, args, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  uploadLaFollowUp(args) {
    return this.axiosIns.post(`${this.jwtConfig.gecPartnerEndPoint}/la/follow-up`, args, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  retryLaImport(logId) {
    return this.axiosIns.patch(`${this.jwtConfig.gecPartnerEndPoint}/la/retry-process/${logId}`)
  }

  getPartnerExcelLogs(...args) {
    return this.axiosIns.get(`${this.jwtConfig.gecPartnerEndPoint}/la/excel-logs`, ...args)
  }

  checkPartnerLaSchedule(...args) {
    return this.axiosIns.post(`${this.jwtConfig.gecPartnerEndPoint}/la/test-schedule`, ...args)
  }

  getSchoolAndDistrictSettings(args) {
    if (!getUserData()) {
      return new Promise(resolve => {
        resolve({})
      })
    }
    return this.axiosIns.get(`${this.jwtConfig.userEndpoint}/school-district-settings`, args)
  }

  getSystemLocale() {
    return this.axiosIns.get(`${this.jwtConfig.localeEndPoint}/get`)
  }

  updateSystemLocale(...args) {
    return this.axiosIns.post(`${this.jwtConfig.localeEndPoint}/locale-save`, ...args)
  }

  mergeSystemLocale(...args) {
    return this.axiosIns.post(`${this.jwtConfig.localeEndPoint}/locale-merge`, ...args)
  }

  automateProblem(lessonId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.automateProblemEndPoint}/automate/${lessonId}`, ...args)
  }

  automateProblemCbAudio(pageId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.curriculumEndpoint}/automate-audio/${pageId}`, ...args)
  }

  automateProblemCbImage(pageId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.curriculumEndpoint}/automate-image/${pageId}`, ...args)
  }

  bulkCbAssets(cbId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.curriculumEndpoint}/automate-bulk/${cbId}`, ...args)
  }

  fullCbBulkAsset(lessonId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.curriculumEndpoint}/automate-full/${lessonId}`, ...args)
  }

  bulkProblemCbGenerate(cbId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.curriculumEndpoint}/automate-problem-gen/${cbId}`, ...args)
  }

  updateEbookBookContent(metaId, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.curriculumEndpoint}/update-meta/${metaId}`, ...args)
  }

  // conversational mode
  setupConversationalModeProblem(classRoomId, lessonId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.conversationalMode}/setup/${classRoomId}/lesson/${lessonId}`, ...args)
  }

  checkConversationalModeProblem(testStatId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.conversationalMode}/check/${testStatId}`, ...args)
  }

  createVocabEventProblem(...args) {
    return this.axiosIns.post(`${this.jwtConfig.vocabEventEndPoint}/add`, ...args)
  }

  getVocabEventInfo(id) {
    return this.axiosIns.get(`${this.jwtConfig.vocabEventEndPoint}/${id}/info`)
  }

  uploadVocabCsv(...args) {
    return this.axiosIns.post(`${this.jwtConfig.vocabEventEndPoint}/upload-vocab-csv`, ...args)
  }

  // vocab class Room
  getVocabClassRoomDashboard(classId) {
    return this.axiosIns.get(`${this.jwtConfig.vocabClassRoomEndPoint}/${classId}/dashboard`)
  }

  // vocab word
  getVocabWordEventData(eventId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.vocabWordEndPoint}/event/${eventId}`, ...args)
  }

  submitVocabWordEventData(...args) {
    return this.axiosIns.post(`${this.jwtConfig.vocabWordEndPoint}/check-answer`, ...args)
  }

  getVocabLessonReport(eventId) {
    return this.axiosIns.get(`${this.jwtConfig.vocabWordEndPoint}/get-result/${eventId}`)
  }

  getVocabLessonReportByProgress(classId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.vocabWordEndPoint}/get-report-by-progress/${classId}`, ...args)
  }

  createLessonFromDataBlock(lessonId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.cbBatchEndPoint}/generate-from-data-block/${lessonId}`, ...args)
  }

  // cefr formula endpoint
  storeCefrFormula(...args) {
    return this.axiosIns.post(`${this.jwtConfig.cefrFormulaEndPoint}`, ...args)
  }

  updateCefrFormula(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.cefrFormulaEndPoint}/${id}`, ...args)
  }

  getCefrFormula(...args) {
    return this.axiosIns.get(`${this.jwtConfig.cefrFormulaEndPoint}`, ...args)
  }

  deleteCefrFormula(id) {
    return this.axiosIns.delete(`${this.jwtConfig.cefrFormulaEndPoint}/${id}`)
  }

  getEquivalentCefrScore(...args) {
    return this.axiosIns.get(`${this.jwtConfig.cefrFormulaEndPoint}/equivalentScore`, ...args)
  }

  // lesson prompt
  getStudentLabPrompt(...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonPromptEndPoint}/lab`, ...args)
  }

  saveLessonPrompt(lessonId, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.lessonPromptEndPoint}/${lessonId}/save`, ...args)
  }

  getLessonPrompt(lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonPromptEndPoint}/${lessonId}/fetch`, ...args)
  }

  getLessonPromptOfSpecificView(lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonPromptEndPoint}/${lessonId}/lab-view`, ...args)
  }

  getProgressReport(classRoom, reportType, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.progressReportEndPoint}/${classRoom}/${reportType}`, ...args)
  }

  uploadLessonTemplate(...args) {
    return this.axiosIns.post(`${this.jwtConfig.calendarEventEndpoint}/upload-csv`, ...args)
  }

  // lab meta
  getLabMetaInfo(...args) {
    return this.axiosIns.get(`${this.jwtConfig.labMetaEndPoint}/get-info`, ...args)
  }

  updateLabMetaInfo(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.labMetaEndPoint}/update/${id}`, ...args)
  }

  updateLabGeneratedWord(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.labMetaEndPoint}/update-gw/${id}`, ...args)
  }

  updateStandardMainPoints(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.standard}/${id}/update-main-point`, ...args)
  }

  saveFcmToken(...args) {
    return this.axiosIns.post(`${this.jwtConfig.commonEndpoint}/save-mobile-fcm-token`, ...args)
  }

  createReaAssignment(...args) {
    return this.axiosIns.post(`${this.jwtConfig.reaAssignmentEndPoint}`, ...args)
  }

  showReaAssignment(id) {
    return this.axiosIns.get(`${this.jwtConfig.reaAssignmentEndPoint}/${id}`)
  }

  cloneImageLibrary(id, ...args) {
    return this.axiosIns.post(`${this.jwtConfig.imageLibraryEndpoint}/${id}/clone`, ...args)
  }

  showReaBasedOnStandard(id) {
    return this.axiosIns.get(`${this.jwtConfig.reaAssignmentEndPoint}/${id}/standard`)
  }

  updateReaAssignment(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.reaAssignmentEndPoint}/${id}`, ...args)
  }

  getCBParagraphsByLesson(lessonId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonsEndpoint}/${lessonId}/paragraphs`, ...args)
  }

  getNextStandard(id, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.standard}/${id}/next`, ...args)
  }

  getReaHistory(...args) {
    return this.axiosIns.get(`${this.jwtConfig.reaAssignmentEndPoint}/history/all`, ...args)
  }

  removeReaHistory(...args) {
    return this.axiosIns.delete(`${this.jwtConfig.reaAssignmentEndPoint}/history/clear`, ...args)
  }

  createControlPage(...args) {
    return this.axiosIns.post(`${this.jwtConfig.controlSystemEndPoint}/pages`, ...args)
  }

  getControlPages(...args) {
    return this.axiosIns.get(`${this.jwtConfig.controlSystemEndPoint}/pages`, ...args)
  }

  createControlPageTasks(...args) {
    return this.axiosIns.post(`${this.jwtConfig.controlSystemEndPoint}/tasks`, ...args)
  }

  editControlPageTasks(id, ...args) {
    return this.axiosIns.put(`${this.jwtConfig.controlSystemEndPoint}/tasks/${id}`, ...args)
  }

  getControlPageTasks(pageId) {
    return this.axiosIns.get(`${this.jwtConfig.controlSystemEndPoint}/pages/${pageId}/tasks`)
  }

  deleteControlPageTasks(id) {
    return this.axiosIns.delete(`${this.jwtConfig.controlSystemEndPoint}/tasks/${id}`)
  }

  getReaPrompts() {
    return this.axiosIns.get(`${this.jwtConfig.reaEndPoint}/rea-prompt`)
  }

  splitAndParsePdf(formData, config = {}) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/split/parse`, formData, config)
  }

  createPdfParser(...args) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}`, ...args)
  }

  deletePdfParser(id) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/${id}`)
  }

  getPdfParsers(...args) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}`, ...args)
  }

  getPdfParsersByCourse() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/grouped`)
  }

  getPdfParsersByCourseLight() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/grouped-lite`)
  }

  getPdfParserInProgressStatuses() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/in-progress`)
  }

  getPdfParserExtra(id) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/${id}/extra`)
  }

  getPdfParserDividerLabel(id) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/${id}/divider-label`)
  }

  updatePdfParserDividerLabel(id, dividerLabel) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/${id}/divider-label`, { divider_label: dividerLabel })
  }

  describePdfParserImages(id, language = 'English') {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/${id}/describe-images`, { language })
  }

  getPdfParserCourseChapters(gradeName, courseName, chapterIds = null) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/course/chapters`, {
      params: {
        grade_name: gradeName,
        course_name: courseName,
        ...(chapterIds && chapterIds.length ? { chapter_id: chapterIds } : {}),
      },
    })
  }

  getPdfParserFailedChapters() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/course/failed-chapters`)
  }

  getPdfParserChapterContent(parserCourseId, chapterNo) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/chapter`, {
      params: { parser_course_id: parserCourseId, chapter_no: chapterNo },
    })
  }

  // data: { chapters: { pdfParserIds: number[], order: number }[] }
  reorderPdfParserChapters(...args) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/reorder-chapters`, ...args)
  }

  reorderPdfParserGrades(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/reorder-grades`, data)
  }

  reorderPdfParserCourses(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/reorder-courses`, data)
  }

  deletePdfParserCourse(data) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/course/delete`, { data })
  }

  clonePdfParserCourse(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/clone`, data)
  }

  clonePdfParserSelectedChapters(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/clone-selected`, data)
  }

  cancelPdfParserClone(jobKey) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/clone/${jobKey}/cancel`)
  }

  generatePdfParserHtml(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/generate-html`, data)
  }

  cancelPdfParserHtml(jobKey) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/generate-html/${jobKey}/cancel`)
  }

  generatePdfParserVideo(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/generate-video`, data)
  }

  getPdfParserVideo(jobKey) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/generate-video/${jobKey}`)
  }

  cancelPdfParserVideo(jobKey) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/generate-video/${jobKey}`)
  }

  cancelActivePdfParserVideos(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/generate-video/cancel-active`, data)
  }

  generatePdfParserInfographic(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/generate-infographic`, data)
  }

  getPdfParserInfographic(jobKey) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/generate-infographic/${jobKey}`)
  }

  cancelPdfParserInfographic(jobKey) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/generate-infographic/${jobKey}`)
  }

  cancelActivePdfParserInfographics(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/generate-infographic/cancel-active`, data)
  }

  getPdfParserInfographicForChapter(id) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/${id}/infographic`)
  }

  uploadPdfParserInfographic(pdfParserId, formData, config) {
    return this.axiosIns.post(
      `${this.jwtConfig.pdfParserEndPoint}/${pdfParserId}/infographics/upload`,
      formData,
      config,
    )
  }

  deletePdfParserInfographic(id) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/infographics/${id}`)
  }

  getPdfParserAcademicVideo(id) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/${id}/academic-video`)
  }

  deletePdfParserAcademicVideo(id) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/academic-videos/${id}`)
  }

  unlinkPdfParserAcademicVideo(id) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/academic-videos/${id}/unlink`)
  }

  uploadPdfParserAcademicVideo(pdfParserId, formData, config) {
    return this.axiosIns.post(
      `${this.jwtConfig.pdfParserEndPoint}/${pdfParserId}/academic-videos/upload`,
      formData,
      config,
    )
  }

  linkPdfParserAcademicVideo(pdfParserId, data) {
    return this.axiosIns.post(
      `${this.jwtConfig.pdfParserEndPoint}/${pdfParserId}/academic-videos/link`,
      data,
    )
  }

  // Destination picker for moving/cloning saved videos: grade → course → lesson.
  getAcademicVideoTransferGrades() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/academic-videos/transfer/grades`)
  }

  getAcademicVideoTransferCourses(gradeName) {
    return this.axiosIns.get(
      `${this.jwtConfig.pdfParserEndPoint}/academic-videos/transfer/courses`,
      { params: { grade_name: gradeName } },
    )
  }

  getAcademicVideoTransferLessons(parserCourseId) {
    return this.axiosIns.get(
      `${this.jwtConfig.pdfParserEndPoint}/academic-videos/transfer/lessons`,
      { params: { parser_course_id: parserCourseId } },
    )
  }

  transferPdfParserAcademicVideos(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/academic-videos/transfer`, data)
  }

  getLessonParserChapters(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/parser-chapters`)
  }

  getLessonShow(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.lessonsEndpoint}/${lessonId}`)
  }

  getLessonLinkableParserChapters(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/linkable-parser-chapters`)
  }

  linkLessonParserChapter(lessonId, data) {
    return this.axiosIns.patch(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/parser-chapter`, data)
  }

  // currently stored lesson HTML & Markdown urls ({ lesson_html_url, lesson_md_url })
  getLessonDocuments(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/generated-documents`)
  }

  // queue lesson HTML & Markdown generation (progress via getQueueProgress(job_key))
  generateLessonDocuments(lessonId) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/generate-documents`)
  }

  // prompts sent to the AI for lesson HTML & Markdown generation, shared by all lessons
  // ({ html, markdown }, each { prompt, default_prompt, is_custom })
  getLessonDocumentPrompts(lessonId) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/document-prompts`)
  }

  // save { html?, markdown? }; null resets that format to the built-in prompt
  updateLessonDocumentPrompts(lessonId, data) {
    return this.axiosIns.put(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/document-prompts`, data)
  }

  uploadLessonInfographic(lessonId, formData, config) {
    return this.axiosIns.post(
      `${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/infographics/upload`,
      formData,
      config,
    )
  }

  replaceLessonInfographic(lessonId, id, formData, config) {
    return this.axiosIns.post(
      `${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/infographics/${id}/replace`,
      formData,
      config,
    )
  }

  updateLessonInfographic(lessonId, id, data) {
    return this.axiosIns.patch(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/infographics/${id}`, data)
  }

  deleteLessonInfographic(lessonId, id) {
    return this.axiosIns.delete(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/infographics/${id}`)
  }

  reorderLessonInfographics(lessonId, data) {
    return this.axiosIns.put(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/infographics/reorder`, data)
  }

  uploadLessonAcademicVideo(lessonId, formData, config) {
    return this.axiosIns.post(
      `${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/academic-videos/upload`,
      formData,
      config,
    )
  }

  linkLessonAcademicVideo(lessonId, data) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/academic-videos/link`, data)
  }

  replaceLessonAcademicVideo(lessonId, id, formData, config) {
    return this.axiosIns.post(
      `${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/academic-videos/${id}/replace`,
      formData,
      config,
    )
  }

  updateLessonAcademicVideo(lessonId, id, data) {
    return this.axiosIns.patch(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/academic-videos/${id}`, data)
  }

  deleteLessonAcademicVideo(lessonId, id) {
    return this.axiosIns.delete(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/academic-videos/${id}`)
  }

  reorderLessonAcademicVideos(lessonId, data) {
    return this.axiosIns.put(`${this.jwtConfig.apiEndPoint}/lesson/${lessonId}/academic-videos/reorder`, data)
  }

  getPdfParserHtmlTemplate() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/html-template`)
  }

  updatePdfParserHtmlTemplate(data) {
    return this.axiosIns.put(`${this.jwtConfig.pdfParserEndPoint}/html-template`, data)
  }

  getPdfParserHtmlTemplates() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/html-templates`)
  }

  getPdfParserHtmlTemplateByKey(key) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/html-templates/${key}`)
  }

  createPdfParserHtmlTemplate(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/html-templates`, data)
  }

  updatePdfParserHtmlTemplateByKey(key, data) {
    return this.axiosIns.put(`${this.jwtConfig.pdfParserEndPoint}/html-templates/${key}`, data)
  }

  deletePdfParserHtmlTemplate(key) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/html-templates/${key}`)
  }

  // Generic prompt templates: type is one of interactive_html,
  // language_translation, video_generation. Backs the "Template Type" picker in
  // HtmlTemplateModal.vue and the inline pickers in CreateHtmlModal.vue,
  // CloneCourseModal.vue and GenerateVideoModal.vue.
  getPdfParserPromptTemplates(type) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/prompt-templates/${type}`)
  }

  getPdfParserPromptTemplate(type, key) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/prompt-templates/${type}/${key}`)
  }

  createPdfParserPromptTemplate(type, data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/prompt-templates/${type}`, data)
  }

  updatePdfParserPromptTemplate(type, key, data) {
    return this.axiosIns.put(`${this.jwtConfig.pdfParserEndPoint}/prompt-templates/${type}/${key}`, data)
  }

  deletePdfParserPromptTemplate(type, key) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/prompt-templates/${type}/${key}`)
  }

  getPdfParserGeneratedHtml(id) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/generated-html`, { params: { id } })
  }

  updatePdfParserGeneratedHtml(data) {
    return this.axiosIns.put(`${this.jwtConfig.pdfParserEndPoint}/generated-html`, data)
  }

  getPdfParserHtmlUrls(id) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/${id}/html-urls`)
  }

  addPdfParserHtmlEntry(id, html) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/${id}/html-urls`, { html })
  }

  getPdfParserHtmlEntry(entryId) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/html-urls/${entryId}`)
  }

  updatePdfParserHtmlEntry(entryId, html) {
    return this.axiosIns.put(`${this.jwtConfig.pdfParserEndPoint}/html-urls/${entryId}`, { html })
  }

  deletePdfParserHtmlUrl(id) {
    return this.axiosIns.delete(`${this.jwtConfig.pdfParserEndPoint}/html-urls/${id}`)
  }

  retryPdfParser(id, data = {}) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/${id}/retry`, data)
  }

  renamePdfParserGrade(data) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/rename-grade`, data)
  }

  renamePdfParserCourse(data) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/rename-course`, data)
  }

  // data: { pdfParserIds: number[], newChapterNo: string }
  renamePdfParserChapter(data) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/rename-chapter`, data)
  }

  createPdfParserChapter(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/create-chapter`, data)
  }

  getParserCourses() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/courses`)
  }

  savePdfParserImage(data) {
    return this.axiosIns.post(`${this.jwtConfig.pdfParserEndPoint}/save-image`, data)
  }

  // Editor links: grade -> library, course -> book, chapter -> lesson.
  getPdfParserLibraries() {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/libraries`)
  }

  getPdfParserLibraryCourses(libraryId) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/library-courses`, {
      params: { library_id: libraryId },
    })
  }

  getPdfParserCourseLessons(courseId, parserCourseId = null, pdfParserId = null) {
    return this.axiosIns.get(`${this.jwtConfig.pdfParserEndPoint}/course-lessons`, {
      params: {
        course_id: courseId,
        ...(parserCourseId ? { parser_course_id: parserCourseId } : {}),
        ...(pdfParserId ? { pdf_parser_id: pdfParserId } : {}),
      },
    })
  }

  assignPdfParserGradeLibrary(data) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/grade/library`, data)
  }

  assignPdfParserCourse(data) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/course/link`, data)
  }

  assignPdfParserLesson(data) {
    return this.axiosIns.patch(`${this.jwtConfig.pdfParserEndPoint}/chapter/lesson`, data)
  }

  getStudentProgressReport(classRoom, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.progressReportEndPoint}/${classRoom}/student-progress-report`, ...args)
  }

  getPromptInfo(...args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/get-prompt-info`, ...args)
  }

  getLearningCoachVariables(type, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.aiIdeEndPoint}/learning-coach/setup/${type}`, ...args)
  }

  getOverallLessonList(...args) {
    return this.axiosIns.get(`${this.jwtConfig.lessonsEndpoint}/all`, ...args)
  }

  saveInTempLog(...args) {
    return this.axiosIns.post(`${this.jwtConfig.commonEndpoint}/save-in-temp-log`, ...args)
  }

  getTempLog(...args) {
    return this.axiosIns.get(`${this.jwtConfig.commonEndpoint}/get-temp-log`, ...args)
  }

  getNetworkUsers(...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/network-users`, ...args)
  }

  updateNetworkCover(networkId, coverData, ...args) {
    // coverData should be a FormData instance containing the new cover image
    return this.axiosIns.post(
      `${this.jwtConfig.apiEndPoint}/network/${networkId}/cover`,
      coverData,
      ...args,
    )
  }

  createAnalyticsRecord(...args) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/analytics/records`, ...args)
  }

  updateAnalyticsRecord(...args) {
    return this.axiosIns.post(`${this.jwtConfig.apiEndPoint}/analytics/records/update`, ...args)
  }

  mapBbbClassRoom(...args) {
    return this.axiosIns.put(`${this.jwtConfig.apiEndPoint}/analytics/records/map-room`, ...args)
  }

  destroyBbHistory(meetingId, ...args) {
    return this.axiosIns.delete(`${this.jwtConfig.apiEndPoint}/analytics/meeting/${meetingId}`, ...args)
  }

  getClassEligibility(classId, ...args) {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/class/${classId}/eligibility`, ...args)
  }

  getGitLogs(...args) {
    return this.axiosIns.get(this.jwtConfig.gitLogsEndpoint, ...args)
  }

  getGitLogsSummary(...args) {
    return this.axiosIns.post(this.jwtConfig.gitLogsSummaryEndpoint, ...args)
  }

  getGoogleAnalytic() {
    return this.axiosIns.get(`${this.jwtConfig.apiEndPoint}/analytics`)
  }

  logoutAllStudents(classroomId) {
    return this.axiosIns.post(`${this.jwtConfig.classEndpoint}/${classroomId}/logoutall`)
  }
}
export default JwtServiceMore
